// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from '../TEMPLATE'

export const Indiegogo = createSinglePathSVG({
  path: 'M18.095 15.664c-1.986 0-2.26-1.344-2.26-3.53 0-2.168.274-3.512 2.26-3.512 1.969 0 2.242 1.344 2.242 3.512 0 2.186-.273 3.53-2.242 3.53m0-10.464C23.125 5.2 24 8.443 24 12.009c0 3.548-.893 6.791-5.905 6.791-5.03 0-5.923-3.243-5.923-6.791v-.112c.02-3.521.946-6.697 5.923-6.697ZM6.16 5.2c1.676 0 3.17.43 4.192 1.075L8.42 9.232c-.62-.341-1.368-.61-2.424-.61-1.422 0-2.37.376-2.37 3.494 0 2.992.566 3.745 2.225 3.745 1.673 0 1.73-.573 1.73-1.864v-.482H5.255l.398-2.885h5.228v8.009h-3.32c-.58.108-1.255.161-2.039.161C1.094 18.8 0 16.022 0 12.009 0 7.404 1.495 5.2 6.16 5.2Z',
  viewBox: '0 0 24 24',
  glyph: 'Indiegogo',
})
